module.exports = __webpack_public_path__ + "static/media/viking.c686c4e5.jpg";